/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppRouterDefinition from "./../../../AppRouterDefinition";
import VerticalSplit from "./../../../Basis/Components/VerticalSplit";

const ImporteView = React.lazy(() => import(/* webpackChunkName: "Importe" */ "../Views/ImporteView"));
const ImportView = React.lazy(() => import(/* webpackChunkName: "Importe" */ "../Views/ImportView"));
const ImporteNavigationView = React.lazy(() => import(/* webpackChunkName: "Importe" */ "../Views/ImporteNavigationView"));
const ImportDetailsView = React.lazy(() => import(/* webpackChunkName: "Importe" */ "../Views/ImportDetailsView"));
const ImporteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Importe" */ "../Components/ImporteBreadcrumb"));
const ImportBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Importe" */ "../Components/ImportBreadcrumb"));

const IMPORTE_PATH = "/importe";
const IMPORT_PATH = "/import/:csvImportId";

export const importeRouterDefinitions: Array<AppRouterDefinition> = [
    {
        path: IMPORTE_PATH,
        render: () => <ImporteView />,
        createBreadcrumbs: () => [<ImporteBreadcrumb />],
    },
    {
        path: IMPORT_PATH,
        render: props => <VerticalSplit
            left={() => <ImporteNavigationView {...props}/>}
            right={() => <ImportView {...props}/>}
        />,
        createBreadcrumbs: props => [
            <ImporteBreadcrumb />,
            <ImportBreadcrumb {...props}/>
        ]
    },
    {
        path: IMPORT_PATH,
        parentPath: IMPORT_PATH,
        exact: true,
        render: props => <ImportDetailsView {...props} />,
        createBreadcrumbs: props => [
            <ImporteBreadcrumb />,
            <ImportBreadcrumb {...props}/>
        ]
    },
];